import { useEffect } from "react";
import "src/App.css";
import { TextProvider } from "src/providers/TextProvider";
import { HomeView } from "src/views/HomeView";
import { CurrentExerciseProvider } from "src/providers/CurrentExerciseProvider";
import { CursorProvider } from "src/providers/CursorProvider";
import { ThemeProvider } from "src/providers/theme/ThemeProvider";
import { logPageView } from "./utils/analytics";

function App() {
  useEffect(() => {
    logPageView();
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <CurrentExerciseProvider>
          <TextProvider>
            <CursorProvider>
              <HomeView />
            </CursorProvider>
          </TextProvider>
        </CurrentExerciseProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
